import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LoggerService } from '../logger/logger.service';

/**
 * Service to handle exceptions and error
 */
@Injectable({
  providedIn: 'root'
})
export class ExceptionHandlerService implements ErrorHandler {

  constructor(private loggerService: LoggerService) { }

  /**
   * Function to handle all the application runtime exceptions and errors
   *
   * @param error Error to be logged
   */
  handleError(error: Error) {
    if (environment.production) {
      this.loggerService.logError(error);
    } else {
      console.log(error);
    }
  }
}
